import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, HeartPulseIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const badges = [{
  icon: ZapIcon,
  label: 'Ajustes de 30 segundos'
}, {
  icon: HeartPulseIcon,
  label: 'Sin medicamentos químicos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Hero() {
  return <header className="w-full bg-forest-900 text-cream-100" data-id="element-46" data-mp="1297a3xzwwp6o">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:py-20" data-id="element-47" data-mp="128pgza8jqr2z">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-48" data-mp="sbb5lp1hcshj">
          <p className="mb-5 inline-block rounded-full border border-clay-400/50 bg-clay-500/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-clay-400" data-id="element-49" data-mp="neawf59c39m7">
            Método Biohacking Canino · 2026
          </p>
          <h1 className="font-display text-[2rem] font-black leading-[1.08] tracking-tight sm:text-5xl lg:text-[3.4rem]" data-id="element-50" data-mp="3j8se7xjcfdo9">
            Cómo duplicar la esperanza de vida de tu perro y ahorrar miles en veterinarios{' '}
            <span className="text-clay-400" data-id="element-51" data-mp="39b4ip5dwy251">sin gastar una fortuna en comida.</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-cream-200/85 sm:text-lg" data-id="element-52" data-mp="3e8mtz2fektg7">
            El Método "Biohacking Canino" que está revolucionando la salud de las mascotas en 2026.
          </p>

          <div className="mt-8" data-id="element-53" data-mp="359t0hkxdcj6v">
            <CtaButton data-id="element-54" data-mp="35a2hij0frg0f" />
          </div>

          <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-55" data-mp="2qk3hsbt8fwiu">
            {badges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm text-cream-200/80" data-id="element-56" data-mp="2vi50uwqnrvub">
                <Icon className="h-4 w-4 text-clay-400" aria-hidden="true" data-id="element-57" data-mp="2hix2u768etrp" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="relative" data-id="element-58" data-mp="s21gc6a6u3xc">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/2273f92e-4d8d-4aca-b665-d9fb798ff73e.jpg" alt="Perro golden retriever sano corriendo por un campo al atardecer" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-2xl" data-id="element-59" data-mp="ibow6f6accrq" />
          <div className="absolute -bottom-5 left-4 right-4 rounded-2xl border border-forest-700 bg-forest-800 px-5 py-4 shadow-xl sm:left-8 sm:right-auto sm:max-w-xs" data-id="element-60" data-mp="161jcx7tq6lh9">
            <p className="font-display text-2xl font-bold text-clay-400" data-id="element-61" data-mp="x14mxv5tgi7f">15 años</p>
            <p className="text-sm text-cream-200/80" data-id="element-62" data-mp="x3h3c3vxekid">
              corriendo como un cachorro. Ese es el objetivo del método.
            </p>
          </div>
        </motion.div>
      </div>
    </header>;
}